// extracted by mini-css-extract-plugin
export default {"subTitle":"index_subTitle__n3LwY","cancel":"index_cancel__EpBDR"};